import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import CounterpartyBankAccountType from "./counterpartyBankAccountType";
import CounterpartyPaymentType from "./counterpartyPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OriginalTransferPaymentResponse {
  @observable
  @Type(() => Date)
  postingDate!: Date;

  @observable
  @Type(() => CounterpartyBankAccountResponse)
  senderBankAccount!: CounterpartyBankAccountResponse;

  @observable
  accountType!: CounterpartyBankAccountType;

  @observable
  paymentType!: CounterpartyPaymentType;
}
